var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlineclipboardEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-eye",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-160.1-233.4c-1.8,0-2.9-0.9-3.1-1c-1.2-0.8-1.9-2-1.9-2.1c-1-1.5-0.2-3,0-3.3c0.6-1.1,1.8-2,2-2.1 c0,0,1.3-1,3.1-1l0,0c1.6,0,2.9,0.9,3.1,1c0,0,1.4,0.9,2,2.2l0,0c0,0,1,1.6,0,3.3c0,0-0.9,1.4-2,2.1 C-157.6-233.9-158.3-233.4-160.1-233.4z M-160-241.4L-160-241.4c-1.3,0-2.2,0.7-2.2,0.7c-0.3,0.2-1.1,0.9-1.5,1.5l-0.1,0.2 c0,0-0.5,0.9,0,1.8c0,0,0.6,1,1.5,1.6c0.2,0.1,1,0.7,2.2,0.7s2.2-0.7,2.2-0.7c1-0.7,1.3-1.1,1.6-1.6c0.6-0.9,0-1.8,0-1.8 c-0.4-0.8-1.3-1.5-1.6-1.7C-158.1-240.8-158.8-241.4-160-241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160-235.6c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5C-157.5-236.7-158.6-235.6-160-235.6z M-160-239.1c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1s1-0.4,1-1S-159.5-239.1-160-239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-162-245.2c-1,0-2.8,0-2.8-2.8 s1.8-2.8,2.8-2.8h4c1,0,2.8,0,2.8,2.8c0,1,0,2.8-2.8,2.8H-162z M-163.2-248c0,1.2,0.3,1.2,1.2,1.2h4c1.2,0,1.2-0.3,1.2-1.2 c0-1.2-0.3-1.2-1.2-1.2h-4C-163-249.2-163.2-249.2-163.2-248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-162.9-229.3c-5.6,0-6.8-2.6-6.8-6.8v-6 c0-4.6,1.6-6.5,5.7-6.7c0.4,0,0.8,0.3,0.8,0.7s-0.3,0.8-0.7,0.8c-2.8,0.2-4.3,1-4.3,5.2v6c0,3.7,0.7,5.2,5.2,5.2h6 c4.5,0,5.2-1.5,5.2-5.2v-6c0-4.2-1.4-5.1-4.3-5.2c-0.4,0-0.7-0.4-0.7-0.8s0.4-0.7,0.8-0.7c4.1,0.2,5.7,2.2,5.7,6.7v6 c0,4.2-1.1,6.8-6.8,6.8H-162.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineclipboardEye);
export default __webpack_public_path__ + "static/media/vuesaxoutlineclipboard-eye.9bf02888d53705b61475f943b59b6875.svg";
export { ForwardRef as ReactComponent };